export default __webpack_public_path__ + "static/media/BS_logo.d78860a9.jpg";